export const LocalStorageKey = {
  theme: 'Goldie/Theme',
  sessionId: 'Goldie/Session',
  showLogs: 'Goldie/ShowLogs',
  localAccountId: 'Goldie/LocalAccount',
};
